import React from 'react';
import './ActiveTradesHeader.css';
import TradesSummary from './TradesSummary';

interface SummaryStats {
  ready: number;
  transit: number;
  completed: number;
  cancelled: number;
  totalPoints: number;
}

interface Props {
  stats: SummaryStats;
}

export default function ActiveTradesHeader({ stats }: Props) {
  return (
    <div className="active-trades-header-container">
      <div className="active-trades-header">
        <h2 className="active-trades-title">Active Trades</h2>
        <p className="active-trades-subtitle">
          A summary of your outbound shipments.
        </p>
      </div>
      <TradesSummary stats={stats} />
    </div>
  );
}